import { Box } from "@mui/material";
import { ReactNode, useState } from "react";

import { BaseEntityDto } from "@/core/api/generated/v1";

import AppIconButton from "../Button/AppIconButton";
import AppIcon from "../Icons/AppIcon";
import MenuWithTrigger from "../Menu/MenuWithTrigger";

export interface ActionTriggersProps<TActionIdentifier extends string> {
  currentAction: TActionIdentifier | null;
  startAction: (props: TActionIdentifier) => void;
  entity?: BaseEntityDto | null;
  handleClose: () => void;
  definition: Record<TActionIdentifier, string>;
}

interface ActionHandlersProps<TActionIdentifier extends string> {
  entity?: BaseEntityDto | null;
  currentAction: TActionIdentifier | null;
  cancelAction: () => void;
  completeAction: () => void;
}

export interface EntityMenuOwnProps<TActionIdentifier extends string> {
  isEnabled?: boolean;
  definition: Record<TActionIdentifier, string>;
  actionTriggers?: (props: ActionTriggersProps<TActionIdentifier>) => ReactNode;
  actionHandlers?: (props: ActionHandlersProps<TActionIdentifier>) => ReactNode;
  disabled?: boolean;
  entity?: BaseEntityDto | null;
}

export default function EntityMenu<TActionIdentifier extends string>({
  isEnabled = true,
  disabled,
  entity,
  definition,
  actionTriggers,
  actionHandlers,
}: EntityMenuOwnProps<TActionIdentifier>) {
  const [currentAction, setCurrentAction] = useState<TActionIdentifier | null>(null);

  if (!isEnabled) {
    return null;
  }

  return (
    <>
      <MenuWithTrigger
        trigger={
          <AppIconButton disabled={disabled}>
            <AppIcon of='moreVert' />
          </AppIconButton>
        }
      >
        {({ handleClose }) => (
          <Box>
            {/** Action buttons */}
            {actionTriggers &&
              actionTriggers({
                definition,
                handleClose,
                currentAction: currentAction,
                entity: entity,
                startAction: (actionDefinition) => {
                  setCurrentAction(actionDefinition);
                  handleClose();
                },
              })}
          </Box>
        )}
      </MenuWithTrigger>

      {/** Action handlers */}
      {actionHandlers &&
        actionHandlers({
          entity: entity,
          currentAction: currentAction,
          cancelAction: () => setCurrentAction(null),
          completeAction: () => setCurrentAction(null),
        })}
    </>
  );
}
